import React, { Component } from 'react'
import utils from 'wbap-utils'

/**
 * 高阶组件,拦截React生命周期,将Action中的生命周期方法融入到组件中
 */
export default () => (WrappedComponent) => class HOC extends Component {
  constructor (props) {
    super(props)
    this.state = {
      hasError: false
    }
  }

  /**
   * 该方法会在组件首次渲染之前调用，这个是在render方法调用前可修改state的最后一次机会
   */
  componentWillMount () {
    this.props.model.componentWillMount && this.props.model.componentWillMount()
  }

  /**
   * 这个方法在首次真实的DOM渲染后调用（仅此一次).
   */
  componentDidMount () {
    this.props.model.componentDidMount && this.props.model.componentDidMount()
  }

  /**
   * 当props或者state发生变化时调用
   * 是否应该更新组件，默认返回true。当返回false时，后期函数就不会调用，组件不会在次渲染。
   * @param nextProps 变更后的props
   * @param nextState 变更后的state
   */
  shouldComponentUpdate (nextProps, nextState) {
    // if (this.props.model.shouldComponentUpdate
    //   && this.props.model.shouldComponentUpdate(nextProps, nextState) === true)
    //   return true
    //
    // if (nextState.hasError !== this.state.hasError)
    //   return true
    //
    // for (let o in this.props) {
    //   if (this.props[o] !== nextProps[o])
    //     return true
    // }
    //
    // return false
    this.props.model.shouldComponentUpdate && this.props.model.shouldComponentUpdate()
  }

  /**
   * 当props或者state发生变化时调用
   * 每当我们通过父组件更新子组件props时（这个也是唯一途径），这个方法就会被调用。
   * @param nextProps 变更后的props
   */
  componentWillReceiveProps (nextProps) {
    if (this.state.hasError)
      this.setState({hasError: false, error: undefined})

    this.props.model.componentWillReceiveProps
    && this.props.model.componentWillReceiveProps(nextProps)
  }

  /**
   * 当props或者state发生变化时调用
   * @param nextProps
   * @param nextState
   */
  componentWillUpdate (nextProps, nextState) {
    this.props.model.componentWillUpdate
    && this.props.model.componentWillUpdate(nextProps, nextState)
  }

  /**
   * 如果 render() 函数抛出错误，则会触发该函数
   * @param error 错误信息
   * @param info 错误信息堆栈对象
   */
  componentDidCatch (error, info) {
    // utils.exception.error(error)
    this.setState({hasError: true, error})

    this.props.model.componentDidCatch
    && this.props.model.componentDidCatch(error, info)
  }

  /**
   * 每当组件使用完成，这个组件就必须从DOM中销毁，此时该方法就会被调用。当我们在组件中使用了setInterval，那我们就需要在这个方法中调用clearTimeout
   */
  componentWillUnmount () {
    this.props.model.componentWillUnmount
    && this.props.model.componentWillUnmount()
  }

  componentWillReact () {
    this.props.model.componentWillReact
    && this.props.model.componentWillReact()
  }

  /**
   * 这个方法在更新真实的DOM成功后调用，当我们需要访问真实的DOM时，这个方法就也经常用到。
   */
  componentDidUpdate () {
    this.props.model.componentDidUpdate
    && this.props.model.componentDidUpdate()
  }

  render () {
    if (this.state.hasError) {
      return <div style={{color: 'red'}}>{this.state.error && this.state.error.message}</div>
    }

    if (!WrappedComponent)
      return null

    return <WrappedComponent {...this.props}/>
  }
}



// WEBPACK FOOTER //
// ./src/wbap-core-commit/metaEngine/wrapper.js